import { HttpRequestError } from "../infrastructure/types";

export function handleHttpError(error: unknown, fallbackMessage: string) {
  const err = error as HttpRequestError<unknown>;
  return err?.message || fallbackMessage;
}
